<template>
  <header class="navbar is-fixed-top has-shadow">
    <div class="container">
      <div class="navbar-brand">
        <router-link :to="{ name: 'Home' }" class="navbar-item">
          <img src="../assets/brand-logo.svg" alt="Chinchilla Logo" />
        </router-link>

        <a
          role="button"
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="mobileNavigation"
          @click="toggleMenu"
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </a>
      </div>

      <div id="mobileNavigation" class="navbar-menu">
        <!-- Page Links -->
        <nav
          id="nav"
          role="navigation"
          aria-label="main navigation"
          class="navbar-start"
        >
          <router-link :to="{ name: 'Home' }" exact class="navbar-item"
            >Home</router-link
          >
          <router-link :to="{ name: 'BabyCare' }" exact class="navbar-item"
            >Baby Care</router-link
          >
          <router-link :to="{ name: 'Health' }" exact class="navbar-item"
            >Health</router-link
          >
          <router-link
            :to="{ name: 'HousingAndToys' }"
            exact
            class="navbar-item"
            >Housing & Toys</router-link
          >
          <router-link :to="{ name: 'FAQ' }" exact class="navbar-item"
            >FAQ</router-link
          >
        </nav>

        <!-- Actions -->
        <div class="navbar-end">
          <a
            href="https://www.facebook.com/Chinchilla-Essentials-2696343127058179/"
            class="navbar-item"
            rel="noopener"
            target="_blank"
          >
            <b-icon icon="facebook" size="is-small" custom-size="mdi-24px" />
          </a>
          <a
            href="https://www.twitter.com/chinessentials"
            class="navbar-item"
            rel="noopener"
            target="_blank"
          >
            <b-icon icon="twitter" size="is-small" custom-size="mdi-24px" />
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
let $navBurger
let $navMenu

export default {
  name: 'TheHeader',
  watch: {
    $route() {
      $navBurger.classList.remove('is-active')
      $navMenu.classList.remove('is-active')
    }
  },
  mounted() {
    $navBurger = document.querySelector('.navbar-burger')
    $navMenu = document.querySelector('.navbar-menu')
  },
  methods: {
    toggleMenu() {
      $navBurger.classList.toggle('is-active')
      $navMenu.classList.toggle('is-active')
    }
  }
}
</script>

<style scoped lang="scss">
#nav {
  padding: 10px 0px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
